module.exports = __webpack_public_path__ + "img/IMG-20200829-WA0002.f7e5e970.jpg";